import { lazy, Suspense, useEffect, useState } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import HomeLanding from "./pages/HomeLanding";

const FullApp = lazy(() => import("./FullApp"));

function SectionOpening({ label }: { label: string }) {
  return <main className="section-opening" dir="rtl" role="status" aria-live="polite">
    <div className="section-opening-card">
      <span className="section-opening-spinner" aria-hidden="true" />
      <strong>جارٍ فتح {label}</strong>
      <small>يتم تجهيز أحدث البيانات</small>
    </div>
  </main>;
}

export default function App() {
  const [fullAppRequested, setFullAppRequested] = useState(() => window.location.pathname !== "/" || Boolean(window.location.hash));
  const [openingLabel, setOpeningLabel] = useState("القسم");
  useEffect(() => {
    performance.mark?.("iraq-gold:app-mounted");
    const reveal = () => {
      performance.mark?.("iraq-gold:react-first-frame");
      window.__IRAQ_GOLD_SET_BOOT_PROGRESS__?.(100, "الواجهة جاهزة");
      const bootScreen = document.getElementById("boot-screen");
      if (!bootScreen) return;
      requestAnimationFrame(() => { document.documentElement.dataset.iraqGoldReady = "true"; bootScreen.dataset.ready = "true"; });
      const remove = () => bootScreen.remove();
      bootScreen.addEventListener("transitionend", remove, { once: true });
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) remove();
    };
    const frame = requestAnimationFrame(reveal);
    return () => cancelAnimationFrame(frame);
  }, []);
  useEffect(() => {
    const syncRoute = () => setFullAppRequested(window.location.pathname !== "/" || Boolean(window.location.hash));
    window.addEventListener("hashchange", syncRoute);
    window.addEventListener("popstate", syncRoute);
    return () => { window.removeEventListener("hashchange", syncRoute); window.removeEventListener("popstate", syncRoute); };
  }, []);
  const openFullApp = (label = "القسم") => {
    setOpeningLabel(label);
    setFullAppRequested(true);
  };
  return <ErrorBoundary>{fullAppRequested ? <Suspense fallback={<SectionOpening label={openingLabel} />}><FullApp /></Suspense> : <HomeLanding onOpenApp={openFullApp} />}</ErrorBoundary>;
}
